export type ClockMode = 'hour' | 'minute';
export type ClockPeriod = 'am' | 'pm';

/** Shoot times sit on the quarter hour: 00, 15, 30, 45. */
export const CLOCK_MINUTE_STEP = 15;

export function parseClockTime(value: string | null | undefined): { hour: number; minute: number } | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(String(value || '').trim());
  if (!match) return null;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23 || minute > 59) return null;
  return { hour, minute };
}

export function formatClockTime(hour: number, minute: number): string {
  const h = ((hour % 24) + 24) % 24;
  const m = ((minute % 60) + 60) % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Degrees clockwise from 12, from a point relative to the dial centre. */
export function dialDegrees(dx: number, dy: number): number {
  let deg = (Math.atan2(dx, -dy) * 180) / Math.PI;
  if (deg < 0) deg += 360;
  return deg;
}

/**
 * The hour (0–23) or minute (0–59) under a pointer on the dial.
 * The face is a 12-hour clock; morning or afternoon decides 8 from 20.
 */
export function snapClockMinute(minute: number): number {
  const snapped = Math.round(minute / CLOCK_MINUTE_STEP) * CLOCK_MINUTE_STEP;
  return ((snapped % 60) + 60) % 60;
}

export function timeFromDialPoint(dx: number, dy: number, mode: ClockMode, period: ClockPeriod): number {
  const deg = dialDegrees(dx, dy);
  if (mode === 'minute') return (Math.round(deg / 90) % 4) * CLOCK_MINUTE_STEP;
  const hourOnFace = Math.round(deg / 30) % 12;
  const face = hourOnFace === 0 ? 12 : hourOnFace;
  if (period === 'am') return face === 12 ? 0 : face;
  return face === 12 ? 12 : face + 12;
}

export function handDegrees(mode: ClockMode, hour: number, minute: number): number {
  if (mode === 'minute') return minute * 6;
  return (hour % 12) * 30;
}

export function hourWithPeriod(hour: number, period: ClockPeriod): number {
  const face = hour % 12;
  return period === 'am' ? face : face + 12;
}
